// material-ui
import { Box, Typography } from '@mui/material';

// project import
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import DynamicNavGroup from './DynamicNavGroup';
import DynamicNavGroupForWeed from './DynamicNavGroupForWeed';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

const Navigation = ({app}) => {
    const navGroups = menuItem.items.map((item) => {
        if (item.app === app) {
            switch (item.type) {
                case 'group':
                    return <NavGroup key={item.id} item={item} />;
                case 'dynamic':
                    return <DynamicNavGroup key={item.id} level={1} item={item} />;
                case 'dynamic-weeds':
                    return <DynamicNavGroupForWeed key={item.id} level={1} item={item} />;
                default:
                    return (
                        <Typography key={item.id} variant="h6" color="error" align="center">
                            Fix - Navigation Group
                        </Typography>
                    );
            }
        }
        // Implicitly return null for items that do not match the app prop
        return null;
    }).filter(Boolean); 
    return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
};

export default Navigation;
